import { render, staticRenderFns } from "./KernelProductEditor.vue?vue&type=template&id=791f4400&"
import script from "./KernelProductEditor.vue?vue&type=script&lang=js&"
export * from "./KernelProductEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports